<template>
  <div
    :class="[
      'mb-2',
      'px-3',
      'py-3',
      'job-question',
      'position-relative',
      {
        answered: isJobQuestionAnswered,
        selected: isSelected,
      },
    ]"
    @click="$emit('select-on-div')"
  >
    <b-row>
      <b-col cols="7">
        <span class="job-question-label">
          {{ label }}
        </span>
      </b-col>
      <b-col
        cols="5"
        class="d-flex justify-content-center align-items-start"
        :class="{ 'px-1': isSelected }"
      >
        <slot v-if="!isSelected" name="right-section" />
        <span v-else style="color: #ffffff;" class="font_size_0875rem">
          Current Section
        </span>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col
        cols="12"
        class="job-question-answer flex-column align-items-start"
      >
        <template v-if="responseValues.length">
          <div
            v-for="(value, i) in responseValues"
            :key="'mdjp_rv_' + jobQuestion.id + '_' + i"
            class="text-break"
            v-html="value"
          />
        </template>
        <div v-else v-html="'N/A'" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  getJobQuestionResponseValues,
  isJobQuestionAnswered,
} from '@/helpers/jobQuestionsHelper';
import { SETTINGS_KEYS } from '@/store';

export default {
  name: 'DesiredJobQuestion',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    isSelected: Boolean,
  },
  computed: {
    isJobQuestionAnswered: function () {
      return isJobQuestionAnswered(this.jobQuestion);
    },
    responseValues: function () {
      return getJobQuestionResponseValues(this.jobQuestion);
    },
    label: function () {
      const extraCharacter =
        this.$store.getters.getSetting(
          SETTINGS_KEYS.CHARACTER_FOR_JOB_QUESTION_LABEL
        ) || '';
      return `${this.jobQuestion.label}${extraCharacter}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../sass/variables_mixins';

.job-question {
  background: 0 0 no-repeat padding-box;
  border: 1px solid black;
  border-radius: 0px !important;
  opacity: 1;
  min-height: 80px;
  text-align: left;
  font: normal normal 500 15px/20px $phairify_font_montserrat;
  letter-spacing: 0;
  color: black;

  .job-question-label {
    font: normal normal 500 15px/20px $phairify_font_montserrat;
    font-size: 14px !important;
  }

  .job-question-answer {
    font: normal normal normal 15px/20px $phairify_font_montserrat;
  }

  .edit-section {
    font: normal normal normal 10px/15px $phairify_font_montserrat;
    opacity: 1;
  }

  &.selected {
    color: $phairify_v2_color_white;
    background-color: #00586f;
  }
}
</style>
<style>
.job-question.answered {
  background-color: #D3E2E6 !important;
}
.job-question.selected, .job-question.selected.answered {
  background-color: #00586f !important;
}

.job-question {
  border-radius: 0px !important;
  min-height: unset !important;
  padding: 1.5rem 0.7rem !important;
  border: 1px solid black !important;
}
</style>
